import { observer } from "mobx-react-lite";
import { FC } from "react";
import { SyncState } from "@/components/sync/types";
import styled from "@emotion/styled";
import { SyncStatusIcon } from "@/components/sync/SyncStatusIcon";
import { SyncStatusText } from "@/components/sync/SyncStatusText";

interface Props {
  syncState: SyncState;
}

export const SyncStatus: FC<Props> = observer(({ syncState }) => {
  return (
    <Label>
      <SyncStatusIcon syncState={syncState} />
      <SyncStatusText syncState={syncState} />
    </Label>
  );
});

const Label = styled.div`
  display: flex;
  flexdirection: row;
  align-items: flex-start;
  flex-wrap: nowrap;
  gap: 6px;
  font-size: ${({ theme }) => theme.fontSizes.small};
  line-height: ${({ theme }) => theme.lineHeights.small};
  color: ${({ theme }) => theme.colors.text.secondary};
  padding-inline: ${({ theme }) => theme.spacing["5"]};
  padding-block: ${({ theme }) => theme.spacing["2"]};
`;
